module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-5.05bddaf2.png";